import React from "react";
// import { NewAptForm } from "../../elements/NewAptForm";
import { PropertyWizard } from "../../elements/propertywizard/PropertyWizard";

export const NewLocation = () => {
  // const navigate = useNavigate();

  // const { user } = useContext(AuthContext);

  return (
    <>
      {/* <NewAptForm /> */}
      <PropertyWizard />
    </>
  );
}